import { useEffect, useState } from 'react';
import { checkSupabaseConnection } from '../api/supabaseClient.js';

const INITIAL_STATE = {
  status: 'checking',
  message: 'Supabase 연결 확인 중',
};

export function useSupabaseHealth() {
  const [health, setHealth] = useState(INITIAL_STATE);

  useEffect(() => {
    const controller = new AbortController();

    checkSupabaseConnection({ signal: controller.signal })
      .then((result) => {
        setHealth({
          status: result.ok ? 'connected' : 'error',
          message: result.message,
        });
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') {
          setHealth({
            status: 'error',
            message: 'Supabase 연결 확인 중 오류가 발생했습니다.',
          });
        }
      });

    return () => controller.abort();
  }, []);

  return health;
}
